import React from 'react'
import { List, ListItem, Skeleton, useMediaQuery, useTheme } from '@mui/material'

/**
 * Tariffs skeleton component. Component display skeleton for tariff in case tariff isLoading or tariff isRefetching.
 * @param - No params required
 */
export const TariffDetailsSkeleton = (): JSX.Element => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const textSkeletonWidth = isMobile ? '68%' : '43%'

  const arrayOfSkeletonComponents = [1, 2, 3, 4, 5, 6, 7, 8]

  return (
    <List>
      {arrayOfSkeletonComponents.map(item => {
        return (
          <ListItem key={item} alignItems="center" disableGutters divider sx={{ paddingTop: 2.5, paddingBottom: 2.5 }}>
            <Skeleton variant="rounded" width={textSkeletonWidth} />
            <Skeleton variant="rounded" width={80} style={{ marginLeft: 25 }} />
          </ListItem>
        )
      })}
    </List>
  )
}
